import { RJSFSchema, RegistryWidgetsType } from "@rjsf/utils";

import { ProcessRunFormEnumSelect } from "@/features/project-process-run-form-enum-select";

export const WIDGETS: RegistryWidgetsType<unknown, RJSFSchema> = {
  SelectWidget: ProcessRunFormEnumSelect,
};
